import React, { useState } from "react";
import "./styles.css";
import { IoCloseOutline } from "react-icons/io5";
import { BiLoaderAlt } from "react-icons/bi";

export default function App({setModal, openModal}) {
  // const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  // const openModal = () => {
  //   setModal(!modal);
  // };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  return (
    <div className="App">
     
        {openModal ? (
          <section className="modal__bg">
            <div className="modal__align">
              <div className="modal__content" modal={openModal}>
                <IoCloseOutline
                  className="modal__close"
                  arial-label="Close modal"
                  onClick={() => setModal(false)
                  }
                />
                <div className="modal__video-align">
                  {videoLoading ? (
                    <div className="modal__spinner">
                      <BiLoaderAlt
                        className="modal__spinner-style"
                        fadeIn="none"
                      />
                    </div>
                  ) : null}
                  <iframe
                    className="modal__video-style"
                    onLoad={spinner}
                    loading="lazy"
                    width="800"
                    height="500"
                    src="https://www.youtube.com/embed/puieXm1xskc?si=2OEe_3R0c7Bj2RG4"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </section>
        ) : null}
     
    </div>
  );
}
